"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarTextItem = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const FixedColumn_1 = require("../../3-list-item/FixedColumn");
const MiniTitle_1 = require("../../3-list-item/MiniTitle");
const Arrow_1 = tslib_1.__importDefault(require("../../icons/interactive/Arrow"));
const ToolbarItem_1 = require("./ToolbarItem");
const arrowFlipClass = (0, nano_theme_1.rule)({
    d: 'inline-flex',
    ai: 'center',
    jc: 'center',
    '&:dir(rtl)': {
        transform: 'scaleX(-1)',
    },
});
const ToolbarTextItem = ({ disabled, onClick, onMouseEnter, onMouseMove, onMouseLeave, children, ...rest }) => {
    const arrow = (React.createElement("span", { className: arrowFlipClass },
        React.createElement(Arrow_1.default, { direction: 'r', width: 16, height: 16 })));
    const narrow = rest.small && !children;
    return (React.createElement(ToolbarItem_1.ToolbarItem, { narrow: narrow, autowidth: !narrow, ...rest, skewed: false, compact: true, rounder: true, height: 28, disabled: disabled, onMouseEnter: disabled ? void 0 : onMouseEnter, onMouseMove: disabled ? void 0 : onMouseMove, onMouseLeave: disabled ? void 0 : onMouseLeave, onClick: disabled ? void 0 : onClick }, children ? (React.createElement(FixedColumn_1.FixedColumn, { right: 16, style: { alignItems: 'center' } },
        React.createElement(MiniTitle_1.MiniTitle, null, children),
        React.createElement("div", { style: { marginInlineEnd: -2, display: 'flex', justifyContent: 'center', alignItems: 'center' } }, arrow))) : (arrow)));
};
exports.ToolbarTextItem = ToolbarTextItem;
